import {Injectable} from '@angular/core';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Redirect {
  constructor(
    private router: Router,
  ) {
  }
  to(uri = this.router.url) {
    this.router.navigateByUrl('/TemporaryAliasRedirectFrom', { skipLocationChange: true }).then(() => this.router.navigate([uri]));
  }
}
